import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router';
import * as _ from 'underscore';
import * as moment from 'moment';

import Agenda from '../widgets/Agenda';
import Synopsis from '../rooms/Synopsis';
import FloorPlan from './FloorPlan';
import Reservation from './Reservation';
import Layout from '../Layout';

import Room from '../../models/Room';

import './booking.less';

interface P extends RouteComponentProps<{ arrival: string; departure: string }, {}> {
}

interface S {
    reservations?: Room[];
    guests: { [room: string]: number };
}

export default class Booking extends React.Component<P, S> {

    private get arrival() { return moment( this.props.params.arrival ); }
    private get departure() { return moment( this.props.params.departure ); }

    constructor( props: P, context: any ) {
        super( props, context );

        this.state = { reservations: [], guests: {} };
    }

    componentWillReceiveProps() {
        this.state = { reservations: [], guests: {} };
    }

    private add( room: Room ) {
        this.setState({
            reservations: _.uniq( this.state.reservations.concat( room ), r => r.id ),
            guests: _.defaults( this.state.guests, _.object([[ room.name, room.kind.lo || room.kind.hi ]]) )
        });
    }

    private remove( room: Room ) {
        this.setState({
            reservations: _.without( this.state.reservations, room ),
            guests: _.omit( this.state.guests, room.name )
        });
    }

    private inc( room: Room ) {
        if ( this.state.guests[room.name] < room.kind.hi )
            this.setState({
                guests: _.mapObject( this.state.guests,
                                     (v, k) => k !== room.name ? v : v + 1 )
            });
    }

    private dec( room: Room ) {
        if ( this.state.guests[room.name] > 1 )
            this.setState({
                guests: _.mapObject( this.state.guests,
                                     (v, k) => k !== room.name ? v : v - 1 )
            });
    }

    render() {
        return (
            <Layout id="booking" title="Booking">
              <Agenda arrival={ this.arrival } departure={ this.departure } />

              <div className="row">
                <div className="nine wide main column">
                  <h2>Choose your room on the floor plan</h2>

                  <FloorPlan from={ this.arrival } thru={ this.departure } checked={ this.state.reservations }
                             onAdd={ r => this.add(r) } onRemove={ r => this.remove(r) } />
                  <Synopsis />
                </div>

                <div className="three wide column">
                  <Reservation checkIn={ this.arrival }
                               checkOut={ this.departure }
                               rooms={ this.state.reservations }
                               guests={ this.state.guests }
                               inc={ this.inc.bind( this ) }
                               dec={ this.dec.bind( this ) } />
                </div>
              </div>
            </Layout>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/booking/New.tsx
 **/